// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _map from 'lodash/map'
import Request from '../components/Request'

import { container, maskedStyle } from '../styles'

type Props = {
  requestInfos: Object,
}

export default function requestInfoMaskHoc ({
  requestInfo$,
  getRequestName,
}) {
  return function (WrappedComponent) {
    class Masked extends Component {
      props: Props

      renderInfos () {
        return (
          <div data-test='LoadingProvider' style={maskedStyle}>
            {_map(this.props.requestInfos, (req, i) => <Request
              key={i}
              request={req}
              {...getRequestName(req)}
            />)}
          </div>
        )
      }

      render () {
        const enabled = this.props.requestInfos.length

        return ([
          <WrappedComponent key='_wrapped' {...this.props} />,
          enabled ? (
            <div key='_loading' data-test='requestinfo-test' style={container}>
              {this.renderInfos()}
            </div>
          ) : null,
        ])
      }
    }

    function mapStateToProps (state: Object): Props {
      return {
        requestInfos: requestInfo$(state),
      }
    }

    return connect(mapStateToProps)(Masked)
  }
}
